/* eslint no-param-reassign: "off", no-console: "off" */
const adminUserStore = {
  state: {
    users: [],
    user: null,
    usersLoading: false,
    userAdding: false,
    userUpdating: false,
    userDeleting: false
  },
  mutations: {
    fetchUsers(state, payload) {
      state.users = payload;
    },
    addUser(state, payload) {
      state.users.unshift(payload);
    },
    updateUser(state, payload) {
      state.user = payload;
      const userIndex = state.users.findIndex(u => u.id == payload.id);
      state.users[userIndex] = payload;
      if (userIndex != -1) state.users = [...state.users];
    },
    deleteUser(state, payload) {
      state.users = state.users.filter(f => f.id != payload);
    },
    fetchUser(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    async fetchUsers({ state, commit }) {
      try {
        state.usersLoading = true;
        const res = await fetch('/v2/users');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchUsers', data);
        state.usersLoading = false;
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    async addUser({ dispatch, state, commit }, payload) {
      try {
        state.userAdding = true;
        const res = await fetch('/v2/users', {
          body: JSON.stringify(payload),
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/json' })
        });
        if (!res.ok) throw new Error(await res.text());
        commit('addUser', payload);
        dispatch('fetchUsers');
        state.userAdding = false;
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    async updateUser({ state, commit }, payload) {
      try {
        state.userUpdating = payload.id;
        const res = await fetch(`/v2/users/${payload.id}`, {
          body: JSON.stringify(payload),
          method: 'PUT',
          headers: new Headers({ 'Content-Type': 'application/json' })
        });
        if (!res.ok) throw new Error(await res.text());
        commit('updateUser', payload);
        state.userUpdating = null;
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    async fetchUser({ commit }, payload) {
      try {
        commit('fetchUser', null);
        const res = await fetch(`/v2/users/${payload.id}?includeActivity=true`);
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchUser', data);
        return data;
      } catch (ex) {
        return null;
      }
    },
    async regenerateInviteCode(context, payload) {
      try {
        const res = await fetch(`/v2/users/reinvite/${payload.id}`, {
          method: 'POST'
        });
        return res.ok;
      } catch (ex) {
        return false;
      }
    }
  },
  getters: {

  }
}
export default adminUserStore;
